<template>
 <div class="popup" v-cloak v-if="verifiSettingShow">
     <div class="content" id="verificationSet" :style={height:getheight()}>
           <div class="title">
                  {{$t('language.twoStepverification.verifySet')}}
                 <div class="icon white-close dialog-close" @click="closePage()"></div>
           </div>
           <div class="set-body-content" v-if="stepOneShow">
               <div style="width:100%;height:calc(100% - 30Px);float:left;">
                <div style="float:left;height:35Px;width:100%;fontSize:14Px;">
                {{$t('language.twoStepverification.addWayVerify')}}
                </div>
                <cloud-select ref="cloudSelect"  @changeOption="onChangeOption" :widthVal="300"
				 :selectOption="selectOption" :placeholder="selectValue" style="margin:0 !important;float:left">
                 </cloud-select>
                 <input type="text" style="width:100%;marginBottom:10Px;" v-if="emailInputShow" :placeholder="$t('language.twoStepverification.enterEmail')" class="ftp-cont-right-one"  v-model="emailValue">
                 <cloud-select ref="phoneSelect" @deleteSelectOption="showOtherOptions"  v-if="!emailInputShow"  @changeOption="onChangePhoneOption" :widthVal="300"
				 :selectOption="selectPhoneOption" :placeholder="selectPhoneValue" style="margin:10Px 0 0 0;float:left">
                 </cloud-select>
                  <input type="text" style="width:100%;marginBottom:10Px;" v-if="!emailInputShow" :placeholder="$t('language.twoStepverification.enterPhone')" class="ftp-cont-right-one"  v-model="phoneValue">
                  <div style="width:100%;height:40Px;float:left;">
                  <input type="text" @blur="blur" style="width:64%;marginBottom:10Px;float:left;margin-top:0px;" v-if="!emailInputShow" :placeholder="$t('language.login.verificationCode')" v-model="vcode">
                  <img class="verification-code" v-if="!emailInputShow" @click.stop="refreshAndClearCode()" :src=ficationCode>
                  </div>
                  <div style="color:red;fontSize:14px;float:left;text-algin:left;" v-if="isShowTipByPhoneValue">{{$t('language.twoStepverification.phoneValueTips')}}</div>
                  <div style="color:red;fontSize:14px;float:left;text-algin:left;" v-if="errorShow">{{errorTxt}}</div>
              </div>
              <div style="width:100%;height:30Px;float:left;">
                   <button style="float:right;width:110Px;" @click="sendCode()">{{$t('language.popup.reportPopup.next')}}</button>
              </div>
           </div>
            <div v-if="stepTwoShow" class="set-body-content">
                <div style="width:100%;height:calc(100% - 30Px);float:left;">
                <div style="float:left;width:100%;fontSize:14Px;lineHeight:20Px;">
                {{$t('language.twoStepverification.enterCode')}} <b v-if="emailValue" :title="emailValue">{{emailValue|ellipsisNavi}}</b><b v-if="phoneValue" :title="phoneValue">{{phoneValue|ellipsisNavi}}</b>
                </div>
                <input type="text" style="width:100%;marginBottom:10Px;position:relative;" :style="{top:getTopPx()}" placeholder="Code" class="ftp-cont-right-one"  v-model="code">
                <div v-if="emailValue" style="float:left;width:100%;fontSize:13Px;lineHeight:20Px;">
                    {{$t('language.twoStepverification.enterCodeTip')}}
                </div>
              </div>
              <div style="width:100%;height:30Px;float:left;">
                   <button style="float:right;width:110Px;" @click="vrificationCode()">{{$t('language.popup.reportPopup.next')}}</button>
              </div>
           </div>
             <div v-if="stepThreeShow" class="set-body-content">
                <div style="width:100%;height:calc(100% - 30Px);float:left;">
                     <div style="float:left;height:20Px;width:100%;fontSize:14Px;">
                          <b>{{$t('language.twoStepverification.verificationTurnOn')}}</b>
                     </div>
                     <div style="float:left;color:#6f7886;fontSize:14Px;marginTop:10Px;">{{$t('language.twoStepverification.recoverAccess')}}</div>
                     <div style="float:left;color:#6f7886;fontSize:14Px;marginTop:10Px;">{{$t('language.twoStepverification.longValid')}}</div>
                     <div style="float:left;color:#6f7886;fontSize:14Px;width:100%;marginTop:10Px;">{{$t('language.twoStepverification.newCode')}}</div>
                     <div style="float:left;fontSize:14Px;marginTop:10Px;corlor:#000;"><b>{{recoveyCode}}</b></div>
               </div>
              <div class="buttom-button">
                  <div style="width:100%">
                   <button class="button-finish" @click="finish()">{{$t('language.twoStepverification.finish')}}</button>
                   <button :style="{width:getCodeWidth()}" @click="copyCode($event)">{{$t('language.twoStepverification.copyCode')}}</button>
                  </div>
              </div>
              
           </div>
     </div>
</div>
</template>
<script>
import cloudSelect from "@/components/common/select/set_cloud_select";
import areaCodeUtil from "../../../js/workspace/area_code_utils.js";
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data() {
        return {
            cornet:'86',//区号
            user:commonUtils.getUser(),
            source:null,//打开该界面的来源
            stepOneShow:true,
            stepTwoShow:false,
            stepThreeShow:false,
            verifiSettingShow:false,
            userDevices:[],//用户现在已经绑定的设备
            emailValue:null,
            phoneValue:null,
            emailInputShow:true,
            vcode:null,
            code:null,
            selectValue:this.$t('language.twoStepverification.addAlEmail'),
            selectOption:[
					{
						name: this.$t('language.twoStepverification.addPhone'),
						icon: false,
						id: 1
					}],
		    selectOptionAll: [{
						name:this.$t('language.twoStepverification.addAlEmail'),
						icon: false,
						id: 0
					}, {
						name: this.$t('language.twoStepverification.addPhone'),
						icon: false,
						id: 1
					},				
				],
            onChangePhoneAllOption:areaCodeUtil.areacode,
            selectPhoneOption:[],//可供选择的项
            selectPhoneValue:'United States(+1)',
            deleteOption:null,
            recoveyCode:'7234T-GWXBK-3A8GC-2KRR4-KXD2T',
            errorShow:false,
            refresh: true,
            ficationCode: '',
            vkey:null,
            errorTxt:'',
            phoneCurrentValue:null,//电话号码选中
            isShowTipByPhoneValue: false,//通过地区判断是否需要展示提示
        }
    },
    watch:{
        emailInputShow(newValue,oldValue){
         if(!newValue){
             var that = this;
             this.$nextTick(()=>{
                 if(that.$refs.phoneSelect && that.phoneCurrentValue){
                    that.$refs.phoneSelect.currentValue = that.phoneCurrentValue; 
               }
             });
         }
        },
        verifiSettingShow(newValue,oldValue){
            if(newValue){
            this.refreshAndClearCode();
            this.errorShow=false;
            this.stepOneShow=true;
            //进入到第二步
            this.stepTwoShow=false;
            this.stepThreeShow=false; 
            //var currentValue;
            let that=this;
            that.selectPhoneOption = Object.assign([],areaCodeUtil.areacode);
            if(this.source!='update'){
             if(that.$refs.phoneSelect){
                that.phoneCurrentValue = that.$refs.phoneSelect.currentValue;
             }
            areaCodeUtil.getAreacode(function(res){
            if(res.cornet){
            that.cornet=res.cornet;
            $.each(that.selectPhoneOption,function(i,item){
              if(res.cornet==1 && res.cornet== item.value && item.name=='United States(+1)'){
                that.selectPhoneValue = item.name;
                that.phoneCurrentValue = item.name;
                that.selectPhoneOption.splice(i,1);
                return false;
             }
             if(item.value == res.cornet &&res.cornet!=1){
               that.selectPhoneValue = item.name;
               that.phoneCurrentValue = item.name;
               that.selectPhoneOption.splice(i,1);
               return false;
             }
            });
            }
            });
            }else{
            that.phoneCurrentValue = null;
            $.each(that.selectPhoneOption,function(i,item){
              if(that.cornet==1 && that.cornet== item.value && item.name=='United States(+1)'){
                that.selectPhoneValue = item.name;
                that.selectPhoneOption.splice(i,1);
                return false;
             }
             if(item.value == that.cornet &&that.cornet!=1){
               that.selectPhoneValue = item.name;
                if(that.$refs.phoneSelect){
                 that.$refs.phoneSelect.currentValue = that.selectPhoneValue;
                }
               that.selectPhoneOption.splice(i,1);
               return false;
             }
            });

            }
            
            }
        },
        cornet(newValue,oldValue){
            if(newValue==44) {
                //如果是英国地区，需要增加提示
                this.isShowTipByPhoneValue = true;
            }else {
                //否则去除提示
                this.isShowTipByPhoneValue = false;
            }
        },
    },
    filters:{
             ellipsisNavi(value) {
            let subStr;
            if (!value) return '';
            if (value.length >22) {
                subStr = value.slice(0, 22) + '...';
            } else {
                subStr = value;
            }
            return subStr;
        }
    },
    components:{
        "cloud-select": cloudSelect,
    },
    methods: {
        getCodeWidth(){
            let width=110+'px';
            switch (this.$i18n.locale) {
            case 'deutsch':
                width=120+'px';
                return width;
                break;
            case 'france':
                width=120+'px';
                return width;
                break;
            case 'portuguese':
                width=120+'px';
                return width;
                break;
            case 'spanish':
                width=125+'px';
                return width;
                break;
            case 'italian':
                width=120+'px';
                return width;
                break;
            case 'japanese':
                width=120+'px';
                return width;
                break;
            case 'traditionalChinese':
                width=120+'px';
                return width;
                break;
            case 'chinese':
                 width=120+'px';
                return width;
                break;
        }
        },
        getheight(){
            let height;
            if(this.stepThreeShow){
               height='370Px';
            }
            return height;
        },
         refreshAndClearCode() {
            let userEmail = commonUtils.getUser().email;
            this.vkey = this.Utils.generateVerifyKey();
            this.Utils.doVerifyCodeRequest("generate", {
                params: {
                    email: userEmail //这里是请求接口书需要传的数据
                },
                responseType: 'arraybuffer', //这里是声明期望返回的数据类型
                vkey: this.vkey
            }).then(response => {
                return 'data:image/png;base64,' + btoa(new Uint8Array(response).reduce((data, email) => data + String.fromCharCode(email), ''));
            }).then(data => { //这一次箭头函数是依赖于第一次.then函数处理的data值
                this.ficationCode = data
            });
        },
        getTopPx(){
             var top=0;
            switch (this.$i18n.locale) {
            case 'italian':
                top=15+'Px'
                return top;
                break;
             case 'portuguese':
                top=15+'Px'
                return top;
                break;
            case 'france':
                top=15+'Px'
                return top;
                break;
             case 'deutsch':
                top=15+'Px'
                return top;
                break;
          }
        },
        closePage(){
            this.verifiSettingShow=false;
            this.emailValue = null;
            this.phoneValue = null;
        },
        showOtherOptions(index){
             //删除某一项的下标
           	if (this.deleteOption && this.deleteOption.length > 0) {
					this.selectPhoneOption.splice(this.deleteOption[0].id, 0, {
						id: this.deleteOption[0].id,
						name: this.deleteOption[0].name
					});
					if (this.deleteOption[0].id <= index) {
						this.deleteOption = this.selectPhoneOption.splice(index + 1, 1);
					} else {
						this.deleteOption = this.selectPhoneOption.splice(index, 1);
					}
				} else {
					this.selectPhoneOption.splice(0, 0, {
						id: 0,
						name: this.selectPhoneValue,
                        value: this.cornet
					});
					this.deleteOption = this.selectPhoneOption.splice(index + 1, 1);
				}
				this.$forceUpdate();
        },
        //更改用户后，返回newValue
        onChangeOption(newValue){
             this.selectOption = Object.assign([], this.selectOptionAll);
             this.$refs.cloudSelect.$refs.sel.style.width =400+'Px';
             switch (newValue.replace(/^\s+|\s+$/g, "")) {
                 case this.$t('language.twoStepverification.addPhone'):
                       //this.selectPhoneOption = Object.assign([],areaCodeUtil.areacode);   
                       this.selectOption.splice(1, 1);
                       this.emailInputShow=false;
                       if(this.deleteOption && this.deleteOption.length){
                           this.selectPhoneValue = this.deleteOption[0].name;
                       }
                       this.emailValue=null;
                       break;
                 case this.$t('language.twoStepverification.addAlEmail'):
                       this.selectOption.splice(0, 1);
                       this.emailInputShow=true;
                       this.phoneValue=null;
                       break;  
             }
        },
        onChangePhoneOption(newValue){
            let cornet = newValue.split("+")[1];
            this.cornet=cornet.split(')')[0];
            //console.log('新的区号'+this.cornet);
        },
        sendCode(){
            //发送验证码
           let that = this;
         //执行下一步操作
           if (this.emailInputShow){
                if(!this.emailValue){
                    this.$toast({
                        text: this.$t('language.exception.emailEmpty'),
                        type: 'fail',
                        idValue: "verificationSet"
                    });
                    return false;
                }
                if(this.emailValue.indexOf('@') == -1){
                     this.$toast({
                    text: this.$t('language.login.enterCorrectEmai'),
                    type: 'fail',
                    idValue: "verificationSet"
                   });
                  return false;
                }
                if(!commonstate.emailpattern.test(this.emailValue) && this.emailValue) {
                this.$toast({
                    text: this.$t('language.login.enterCorrectEmai'),
                    type: 'fail',
                    idValue: "verificationSet"
                });
                return false;
                }
                this.phoneValue=null;
                this.Utils.doDualVerifyRequest('send',{userId:this.user.id,email:this.emailValue}).then(res=>{
                     if(res.status==200){
                          that.stepOneShow=false;
                           //进入到第二步
                          that.stepTwoShow=true;
                          that.code=null; 
                     }else{
                        if(res.reason == 'sendTooOften' || res.reason == 'hour24Limit'){
                            that.errorShow=true;
                            that.errorTxt =that.$t('language.twoStepverification.toManyCodeSend');
                            return;
                        }
                        that.$toast({
                        text: that.$t('language.exception.'+res.reason),
                        type: 'fail',
                        idValue: "verificationSet"
                        });
                    return false;
                     }
                });
           }else{
                if(!this.phoneValue){
                    this.$toast({
                        text: this.$t('language.twoStepverification.phoneNotEmpty'),
                        type: 'fail',
                        idValue: "verificationSet"
                    });
                    return false;
                 }
                  if(!this.vcode){
                   that.errorShow=true;
                   that.errorTxt = that.$t('language.login.enterCode');
                   return;
                }
                 let sendData={
                     userId:this.user.id,
                     cornet:this.cornet,
                     phoneNumber:this.phoneValue,
                     captchaKey:this.vkey,
                     captchaValue:this.vcode.trim()
                 }
                this.emailValue="";
                this.Utils.doDualVerifyRequest('send',sendData).then(res=>{
                     //console.log(res);
                     if(res.status==200){
                          that.stepOneShow=false;
                           //进入到第二步
                          that.stepTwoShow=true;
                          that.code=null; 
                     }else{
                        that.vcode=null;
                        that.refreshAndClearCode();
                         if(res.reason == 'sendTooOften' || res.reason == 'hour24Limit'){
                            that.errorShow = true;
                            that.errorTxt = that.$t('language.twoStepverification.toManyCodeSend');
                            return;
                        }
                        if(res.reason == 'captchaError'){
                            that.errorShow = true;
                            that.errorTxt = that.$t('language.login.exception.verifyCodeInvalid');
                            return;
                        }  
                        that.$toast({
                        text: that.$t('language.exception.'+res.reason),
                        type: 'fail',
                        idValue: "verificationSet"
                        });
                    return false;
                     }
                });

           }
      
           
        },
        vrificationCode(){
             let that=this;
             if(this.userDevices[0] && this.phoneValue){
               that.source == 'update';
             }
              if(this.userDevices[1] && this.emailValue){
               that.source == 'update';
             }
             //验证验证码是否正确
             if(that.source != 'update'){
                 let createData;
                 if(this.code){
                     this.code = this.code.trim();
                 }else{//如果没输验证码则报错
                      that.$toast({
                        text: that.$t('language.login.exception.codeEmpty'),
                        type: 'fail',
                        idValue: "verificationSet"
                        });
                       return false;
                 }
                if(this.emailValue){
                     createData={
                      userId:this.user.id,
                      email:this.emailValue,
                      verificationCode:this.code
                    }
                }else{
                     createData={
                      userId:this.user.id,
                      phoneNumber:this.phoneValue,
                      cornet:this.cornet,
                      verificationCode:this.code
                    }
                }
           
             if(that.source == 'addTrust'){
                that.verifyChange(function(){
                      that.verifiSettingShow=false;
                      return;
                }); 
                return;
             }
             this.Utils.doDualVerifyRequest('create',createData).then(res=>{
                  if(res.status == 200){
                      that.recoveyCode = res.recoverCode;
                      that.stepOneShow = false;
                      that.stepTwoShow = false;
                      that.stepThreeShow = true;  
                      that.userDevices = [that.phoneValue,that.emailValue];                
                  }else{
                      that.$toast({
                        text: that.$t('language.exception.'+res.reason),
                        type: 'fail',
                        idValue: "verificationSet"
                        });
                       return false;
                  }
             });
             }else{
                 //如果是进行修改设备操作
                 this.verifyChange(function(){});
             }
        },
        blur(){
            this.errorTxt=null;
        },
        // addTrusted(callback){
        //     let that =this;
        //     let trustData={
        //         userId:this.user.id,
        //         trustedDevice:this.code
        //     }
        //     this.Utils.doDualVerifyRequest('trusted',trustData).then(res=>{
        //         that.getVerifyInfo();
        //         callback(res);
        //     });
        // },
        verifyChange(callback){
            let that = this;
            let changeData;
            if(this.code){
                this.code = this.code.trim();
            }else{
                  that.$toast({
                        text: that.$t('language.login.exception.codeEmpty'),
                        type: 'fail',
                        idValue: "verificationSet"
                        });
                       return false;
            }
            if(this.emailValue){
              changeData={
                userId:this.user.id,
                email:this.emailValue,
                verificationCode:this.code,
            }
            }else{
                changeData={
                userId:this.user.id,
                phoneNumber:this.phoneValue,
                cornet:this.cornet,
                verificationCode:this.code,
            }
            }
            this.Utils.doDualVerifyRequest('change',changeData).then(res=>{
                if(res.status==200){
                that.getVerifyInfo();
                that.userDevices = [that.phoneValue,that.emailValue];     
                that.verifiSettingShow=false;
                callback(res);
                }else{
                        that.$toast({
                        text: res.msg,
                        type: 'fail',
                        idValue: "verificationSet"
                        });
                    return false;
                }
            }); 
        },
        finish(){
             let that=this;
             that.getVerifyInfo();
             this.verifiSettingShow=false;
        },
        getVerifyInfo(){
               let that=this;
               let self=that.$parent.$refs.updateVerificationDialog;
               this.Utils.doDualVerifyRequest('get',{userId:this.user.id}).then(res=>{
                 self.updateVerifiShow=true;
                 self.verificationStatus=res.status;
                 self.emialValue=res.devices[1];
                 self.phoneValue=res.devices[0];
                 if(!self.phoneValue){
                     self.txtShow=false;
                 }else{
                   if(self.phoneValue && self.phoneValue.indexOf("-")!=-1){
                   let index = self.phoneValue.indexOf("-");
                   self.cornet = self.phoneValue.substring(0,index);
                   self.phoneValue = self.phoneValue.substring(index+1);
                    }
                     self.txtShow=true;
                 }
                 if(!self.emialValue){
                     self.emialShow=false;
                 }else{
                     self.emialShow=true;
                 }
                
             });
        },
        copyCode(e){
        const clipboard = new this.clipboard(e.target, {
          text: () => this.recoveyCode
        });
        clipboard.on('success', e => {
          this.$toast({
            text: this.$t('language.twoStepverification.codeCopied'),
            type: 'success',
            idValue: "verificationSet"
          });
        })
        clipboard.on('error', e => {
          clipboard.off('error');
          clipboard.off('success');
        })
        clipboard.onClick(e);
        }
    },

}
</script>

<style>
#verificationSet{
    width: 440Px;
    height: 370Px;
}
.set-body-content{
    width: 100%;
    height: calc(100% - 40Px);
    box-sizing: border-box;
    padding: 30Px 20Px 20Px 20Px;
}
.buttom-button{
    width:100%;
    height:30Px;
    display:flex;
    align-items: center;
    text-align: center;
}

.button-finish, .button-finish:hover{
width:110Px;
margin-right:10px;
color:#5562b4;
background:#fff;
border: 1Px solid #5562b4;
}

.verification-code {
   float: right;
   position: relative;
   top: -5Px;
   height: 39Px;
   width: 140Px;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/verification_setting_popup.vue